import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../firebase/firebase';
const createActivity = async (user, currentUser) => {
    try {

        console.log('✅ Current user 🔥:', user.displayName);

        const userData = user;

        // Make the POST request - Create new group
        const response = await fetch('https://bluejims.com:5005/misbolos/activity', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${currentUser.stsTokenManager.accessToken}`
            },
            body: JSON.stringify(user)
        });

        if (response.ok) {
            console.log('✅ Group data successfully received from netofcomputers.com');
            // You can parse the response if the server sends back any data
            const responseData = await response.json();
            console.log('Server response:', responseData);
            // TODO: navigate to dashboard or store user info
            return responseData.user
        } else {
            console.error('❌ Failed to receive group data from netofcomputers.com:', response.status, response.statusText);
            // Handle non-2xx responses
            return false
        }

    } catch (error) {
        console.error('❌ MisBolosApi /access* or fetch error:', error);
        return false
    }
};


const createGroup = async (user, currentUser) => {
    try {

        console.log('✅ Current user 🔥:', user.displayName);

        const userData = user;

        // Make the POST request - Create new group
        const response = await fetch('https://bluejims.com:5005/misbolos/groups', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${currentUser.stsTokenManager.accessToken}`
            },
            body: JSON.stringify(user)
        });

        if (response.ok) {
            console.log('✅ Group data successfully received from netofcomputers.com');
            // You can parse the response if the server sends back any data
            const responseData = await response.json();
            console.log('Server response:', responseData);
            // TODO: navigate to dashboard or store user info
            return responseData.user
        } else {
            console.error('❌ Failed to receive group data from netofcomputers.com:', response.status, response.statusText);
            // Handle non-2xx responses
            return false
        }

    } catch (error) {
        console.error('❌ MisBolosApi /access* or fetch error:', error);
        return false
    }
};

export { createGroup, createActivity }